import { useState } from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import Radio from 'components/form/radio/Radio';
import { Modal } from 'schola-components';
import LinkButton from 'components/button/v2/LinkButton';
import { tString } from 'components/translation/Translation';
// styles
import styles from './ModalLogalSignUp.module.scss';

export const ModalLogalSignUp = ({ display, isLogin, onClose }) => {
  /**
   * ModalLogalSignUp component receives Props for functionality
   *
   * @param {display}:boolean
   * @param {isLogin}:boolean
   * @param {onClose}:() => void
   *
   * @returns Modal Component
   *
   */

  const [selected, setSelected] = useState('Personal');

  const title = isLogin ? tString('landing:login.title_login') : tString('landing:login.title_signup');
  const link =
    selected === 'Personal'
      ? isLogin
        ? '/login'
        : '/signup'
      : isLogin
      ? `${config.adminHost}/login`
      : `${config.adminHost}/claim`;

  const handleCloseModal = () => {
    setSelected('');
    onClose();
  };

  return (
    <Modal isVisible={display} onClose={handleCloseModal} className={styles.login_modal}>
      <div className={styles.modal_body}>
        <div className={styles.modal_body_header}>
          <div className={styles.modal_body_header_logo}>
            <img width="200" src="https://static.schola.com/ScholaR.svg" alt="Schola® logo" />
          </div>
          <div className={styles.modal_body_header_title}>{title}</div>
        </div>
        <div className={styles.radio_buttons}>
          <div className={styles.radio_content}>
            <Radio
              checked={selected === 'Personal'}
              name="parent_student"
              label={tString('landing:login.parent_or_student')}
              value="parent_student"
              onChange={() => setSelected('Personal')}
            />
            <p className={styles.selected_label}>{tString('landing:login.personal')}</p>
          </div>
          <div className={styles.radio_content}>
            <Radio
              checked={selected === 'Company'}
              name="school"
              label="School"
              value="school"
              onChange={() => setSelected('Company')}
            />
            <p className={styles.selected_label}>{tString('landing:login.company')}</p>
          </div>
        </div>
      </div>
      <div className={styles.modal_footer}>
        <LinkButton className="my-4 button-tertiary" href={link} fullWidth>
          {tString('landing:login.cmd_continue')}
        </LinkButton>
      </div>
    </Modal>
  );
};

export default ModalLogalSignUp;

ModalLogalSignUp.propTypes = {
  display: PropTypes.bool.isRequired,
  isLogin: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
